import { supabase } from '@/integrations/supabase/client';
import { isShareReady } from '@/lib/menuShareReady';

export function canPrepareMenuShare(menu: { company_id: string; is_active: boolean; archived_at?: string | null }, companyId: string, count: number): boolean {
  return menu.company_id === companyId && menu.is_active && !menu.archived_at && isShareReady(count);
}

/** Same menu invitation token and branded preview path as the existing Share window. No sends. */
export async function prepareMenuShareUrl(menuId: string, companyId: string): Promise<string> {
  const { data: existing, error } = await supabase.from('menu_share_tokens')
    .select('token,expires_at,max_uses,use_count').eq('company_id', companyId)
    .eq('menu_id', menuId).eq('is_active', true).order('created_at', { ascending: false });
  if (error) throw error;
  let token = existing?.find(t => (!t.expires_at || new Date(t.expires_at).getTime() > Date.now()) && (t.max_uses == null || t.use_count < t.max_uses))?.token;
  if (!token) {
    const { data, error: createError } = await supabase.from('menu_share_tokens')
      .insert({ company_id: companyId, menu_id: menuId }).select('token').single();
    if (createError) throw createError;
    token = data.token;
  }
  const url = `https://cannafax.ai/menu-invite/${token}`;
  try {
    const { data, error: shortError } = await supabase.functions.invoke('shorten-url', { body: { url } });
    if (!shortError && typeof data?.shortUrl === 'string') return data.shortUrl;
  } catch { /* Existing long invitation URL is a safe fallback. */ }
  return url;
}